import { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { FileInputContext } from '@components/form/photos/FileInputContext'
import Thumbnails from '@components/form/photos/Thumbnails'
import useT from '@hooks/useTranslation'

const PhotosInput = ({
    DragDropArea = null,
    Actions = null,
    ImageEditor = null,
    MessageHelper = null,

    onFileEntry = null,
    onFileDelete = null,
    onFileEdit = null,
    onFileOrderChange = null,
    onDefaultPreload = null,
    onCancel = null,
    onSave = null,
    onExit = null,

    defaultValue = '',
    getDefaultValues = null,

    onCallback,

    debug = false,

    name,
    limit = 15,
    required,
    user }) => {

    const [photos, setPhotos] = useState([])
    const { register, unregister, setValue,
        getProgress } = useFormContext()

    const callback = (array) => setValue(name, array)

    // field registration
    useEffect(() => {
        register(name, { required: Boolean(required) && 'Dodaj chociaż jedno zdjęcie' })
        return () => {
            if (onExit) onExit(photos)
            unregister(name)
        }
    }, [])

    // field default value
    useEffect(() => {
        if (defaultValue && getDefaultValues) {
            getDefaultValues(user, defaultValue, setPhotos, { onDefaultPreload })
                .then(res => null)
                .catch(err => null)
        }
    }, [defaultValue])

    // field setter with custom onCallback transformation
    useEffect(() => {
        if (debug) console.log(photos)
        onCallback
            ? callback(onCallback(photos))
            : callback(photos)
    }, [photos])

    const limitReached = useT('Limit zdjęć w ogłoszeniu wynosi')
    const spaceLeft = useT('Pozostałe miejsce')
    return (
        <FileInputContext.Provider value={{
            ImageEditor, MessageHelper,
            files: photos, setFiles: setPhotos,
            name, limit, required,
            callbacks: {
                onFileEntry,
                onFileDelete,
                onFileEdit,
                onFileOrderChange,
                onDefaultPreload,
                onCancel,
                onSave,
            },
            messages: {
                limitReached,
                spaceLeft,
            }}}>

            <DragDropArea progress={getProgress()}>
                <Thumbnails Actions={Actions} />
            </DragDropArea>
        </FileInputContext.Provider>
    )
}

export default PhotosInput